import { fromJS } from 'immutable';
import { actionTypes } from '../../constants/documentTemplates';
import { combineReducers } from 'redux-immutable';

const initialPackagesListState = fromJS({
  list: [],
  meta: {},
  isLoading: false,
  updateStatusIsLoading: false,
  updateStatusActionResult: null,
});

export function documentTemplatesReducer(state = initialPackagesListState, action) {
  switch (action.type) {
    case actionTypes.FETCH_DOCUMENT_TEMPLATES:
      return state
        .set('list', fromJS(action.payload.data))
        .set('meta', fromJS(action.payload.meta));
    case actionTypes.FETCH_DOCUMENT_TEMPLATES_LOADING:
      return state.set('isLoading', action.payload);
    case actionTypes.RESET_DOCUMENT_TEMPLATES:
      return state.set('list', fromJS([]));
    case actionTypes.SET_UPDATE_DOCUMENT_STATUS_IS_LOADING:
      return state.set('updateStatusIsLoading', action.payload);
    case actionTypes.UPDATE_DOCUMENT_STATUS_ACTION_RESULT:
      return state.set('updateStatusActionResult', action.payload);
    case actionTypes.UPDATE_DOCUMENT_STATUS:
      return state.update('list', list => {
        return list.map(item =>
          item.get('id') === action.payload.id ? item.set('active', action.payload.active) : item,
        );
      });
    default:
      return state;
  }
}

const initialTemplateState = fromJS({
  result: {},
  isLoading: false,
  saveTemplateActionResult: null,
  saveTemplateLoading: false,
});

function documentTemplateReducer(state = initialTemplateState, action) {
  switch (action.type) {
    case actionTypes.GET_TEMPLATE_LOADING:
      return state.set('isLoading', action.payload);
    case actionTypes.GET_TEMPLATE:
      return state.set('result', fromJS(action.payload));
    case actionTypes.RESET_TEMPLATE:
      return state.set('result', fromJS({}));
    case actionTypes.SAVE_TEMPLATE_LOADING:
      return state.set('saveTemplateLoading', action.payload);
    case actionTypes.SAVE_TEMPLATE_ACTION_RESULT:
      return state.set('saveTemplateActionResult', action.payload);
    default:
      return state;
  }
}

export default combineReducers({
  templates: documentTemplatesReducer,
  template: documentTemplateReducer,
});
